import React, { useEffect, useState } from 'react';
import 'react-phone-input-2/lib/style.css';
import { Link, useNavigate } from 'react-router-dom';
import { faEnvelope as faEnvelopeRegular } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { useDispatch, useSelector } from 'react-redux';
import { faGoogle } from '@fortawesome/free-brands-svg-icons';
import { AppDispatch, RootState } from '../../../store/store';
import Loader from '../../../components/Common/Loader';
import BackButton from '../../../components/Common/BackButton';
import { handleTeacherGoogleSignUp } from '../services/teacher-google-signup.service';
import { setRedirectURL } from '../../../store/userSlice';

const GeneralSignUpOptions = () => {
  const dispatch: AppDispatch = useDispatch();
  const navigateTo = useNavigate();

  const [googleLoader, setGoogleLoader] = useState<boolean>(false);
  const userAuthorized = useSelector((state: RootState) => state.user.userAuthorized);
  const user = useSelector((state: RootState) => state.user.user);

  useEffect(() => {
    if (user && userAuthorized) {
      dispatch(setRedirectURL('/'));
    }
  }, [dispatch, user, userAuthorized]);

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col font-sofiaSans justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:max-w-sm sm:mx-auto h-full min-h-full flex flex-1 flex-col justify-between">
        <div></div>
        <div className="sm:mx-auto sm:w-full py-8 px-4 sm:px-12">
          <div className="text-left mb-6">
            <h1 className="text-3xl font-bold text-black mb-3">Bring Your Story to Life!</h1>
            <p className="text-black text-lg">Sign up to create a beautifully illustrated storybook in minutes.</p>
          </div>

          {/* Google Sign Up Button */}
          <div className="mb-4">
            <button
              disabled={googleLoader}
              onClick={() => handleTeacherGoogleSignUp(setGoogleLoader, dispatch, navigateTo)}
              className="w-full flex justify-center gap-3 bg-secondaryStoryOptionalLightBlueText text-white font-bold font-sofiaSans rounded-lg px-4 py-2 text-base items-center cursor-pointer border border-gray-300 hover:shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
            >
              <FontAwesomeIcon
                title="Sign Up with Google"
                icon={faGoogle}
                className="text-xl text-white cursor-pointer"
              />
              Continue with Google
              <Loader loader={googleLoader} />
            </button>
          </div>

          <div className="mb-4">
            <Link
              to="/signup"
              className={`
              w-full flex items-center justify-center border border-secondaryStoryGrayBorder font-sofiaSans hover:shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-colors
              text-secondaryStoryBlackText text-base font-bold rounded-lg px-4 py-2
            `}
            >
              <div className="flex items-center font-bold text-base">
                <div className="pr-2 flex items-center justify-center">
                  <FontAwesomeIcon
                    icon={faEnvelopeRegular as IconProp}
                    className={`text-secondaryStoryBlackText text-2xl `}
                  />
                </div>
                <span>{'Continue with Email'}</span>
              </div>
            </Link>
          </div>

          <div>
            <Link
              to="/signin"
              className={`
              w-full flex items-center justify-center border border-secondaryStoryGrayBorder font-sofiaSans hover:shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-colors
              text-secondaryStoryBlackText text-base font-bold rounded-lg px-4 py-2
            `}
            >
              <div className="flex items-center font-bold text-base">
                <span>Log in</span>
              </div>
            </Link>
          </div>

          <div className="flex items-center justify-between mt-6">
            <div>
              <BackButton onClick={() => window.history.back()}></BackButton>
            </div>
            <img src="/new_black_logo.png" alt="Build My Story" className="h-6" />
          </div>
        </div>
        <div className="sm:max-w-sm sm:mx-auto text-center text-base text-black">
          <Link to="/auth/teacher" className="underline">
            Go to Teacher Login / Sign Up
          </Link>
        </div>
      </div>
    </div>
  );
};

export default GeneralSignUpOptions;
